export var SelectCore;
(function (SelectCore) {
    function make() {
        return {
            distinct: false,
            projections: new Array(),
            froms: new Array(),
            joins: new Array(),
            wheres: new Array(),
            groups: new Array(),
            havings: new Array(),
            windows: new Array(),
        };
    }
    SelectCore.make = make;
    function project(initial, ...sources) {
        return { ...initial, projections: [...initial.projections, ...sources] };
    }
    SelectCore.project = project;
    function from(initial, ...sources) {
        return { ...initial, froms: [...initial.froms, ...sources] };
    }
    SelectCore.from = from;
    function join(initial, ...sources) {
        return { ...initial, joins: [...initial.joins, ...sources] };
    }
    SelectCore.join = join;
    function where(initial, ...sources) {
        return { ...initial, wheres: [...initial.wheres, ...sources] };
    }
    SelectCore.where = where;
    function group(initial, ...sources) {
        return { ...initial, groups: [...initial.groups, ...sources] };
    }
    SelectCore.group = group;
    function having(initial, ...sources) {
        return { ...initial, havings: [...initial.havings, ...sources] };
    }
    SelectCore.having = having;
    function window(initial, ...sources) {
        return { ...initial, windows: [...initial.windows, ...sources] };
    }
    SelectCore.window = window;
})(SelectCore || (SelectCore = {}));
